<template>
  <div class="input__lock">
    <div :class="backdropClass">
      <slot name="button">
        <hcc-button @click="unlock" size="lg" class="input__lock-button">
          {{ $t("chat.unlock-input") }}
        </hcc-button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    HccButton: () => import('@/components/shared/HccButton/index.vue'),
  },
  props: {
    buttonIsVisible: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    backdropClass() {
      return [
        'input__lock-backdrop',
        {
          'is-opened': this.buttonIsVisible,
        },
      ];
    },
  },
  methods: {
    unlock() {
      this.$emit('unlock-clicked');
    },
  },
};
</script>
